module.exports = __webpack_public_path__ + "img/Kiosk.27bffd27.jpg";